import { Module } from 'vuex';
import { StateInterface } from '../index';
import state, { OrderInfoInterface } from './state';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const orderInfoModule: Module<OrderInfoInterface, StateInterface> = {
  namespaced: true,
  actions,
  getters,
  mutations,
  state
};

export default orderInfoModule;
